import { createContext, useContext } from "react";
import { type AppRouteConfigView } from "shared/mappers/database/app-route/app-route-config/app-route-config";

/**
 * The app route config of the page being rendered, for components deep in the
 * page - the header especially - that need route settings such as
 * `platformConfig` without every page passing them down. `undefined` outside a
 * configured route (login, access denied, `/form/:formId`, …).
 */
export const CurrentRouteConfigContext = createContext<
  Partial<AppRouteConfigView> | undefined
>(undefined);

export const useCurrentRouteConfig = ():
  | Partial<AppRouteConfigView>
  | undefined => useContext(CurrentRouteConfigContext);
